import React from 'react';
import { useTranslation } from 'react-i18next';
import waterTreatmentImage from '../assets/images/hero-water-treatment-v2.jpg';

function FirstSection() {
  const { t } = useTranslation();

  return (
    <section className="home-hero" aria-labelledby="home-hero-title">
      <div className="home-hero__container">
        <div className="home-hero__content">
          <p className="home-hero__eyebrow">{t('hero.eyebrow')}</p>
          <h1 id="home-hero-title">{t('hero.title')}</h1>
          <p className="home-hero__description">{t('hero.description')}</p>

          <div className="home-hero__actions">
            <a className="home-hero__button home-hero__button--primary" href="#Contact">
              {t('hero.primaryCta')}
            </a>
            <a className="home-hero__button home-hero__button--secondary" href="#Projects">
              {t('hero.secondaryCta')}
            </a>
          </div>
        </div>

        <div className="home-hero__visual">
          <img
            src={waterTreatmentImage}
            width="1672"
            height="941"
            alt=""
            decoding="async"
          />

          <div className="home-hero__impact">
            <span>{t('hero.impact.prefix')}</span>
            <strong>85%</strong>
            <p>{t('hero.impact.label')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FirstSection;
